<div *ngIf="puedeUsarSaldo && usarSaldoFavor && !cargando && !errorConsulta" class="d-flex justify-content-between py-1" data-testid="balance-summary">
	<strong class="text-color-dark">Saldo a favor:</strong>
	<strong data-testid="balance-applied">-$ {{ saldoAplicadoEsperado | number : "1.0-0" : "es-CL" }}</strong>
</div>
